import {
  COLORS,
  headerHeight,
  orderNavigationHeight,
  subHeaderHeight,
} from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';
import Button from 'components/Button/Button';

// Pages rendering OrderNavigation publish these on their container, so the
// order flow SubHeader and sticky elements can clear the bars above them.
// The SubHeader only counts while it sits at the top: from midTablet down it is
// pinned to the bottom of the screen (see SubHeaderContainer).
export const orderFlowLayoutVars = (hasSubHeader: boolean) => css`
  --app-order-navigation-height: ${orderNavigationHeight};
  --app-order-subheader-top-height: ${hasSubHeader ? subHeaderHeight : '0rem'};

  ${respondTo.midTablet`
    --app-order-subheader-top-height: 0rem;
  `}
`;

export const Container = styled.div`
  background-color: ${COLORS.WHITE};
  width: 100%;
  max-width: 100%;
  position: fixed;
  top: var(--app-header-height, ${headerHeight});
  z-index: 100;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1440rem;
  margin: 0 auto;
  height: ${orderNavigationHeight};

  ${respondTo.smallLaptop`
    padding: 0 15rem;
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10rem;
  flex: 0.5;

  ${respondTo.smallTablet`
    gap: 6rem;
  `}
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 2;
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0.5;
`;

// The bar is fixed height and the tab pills in the middle need the room, so
// these stay on one line and give ground by dropping their label rather than
// by wrapping. See OrderNavigation for which label goes at which width.
export const NavButton = styled(Button)`
  // Button's own wrapper adds padding around anything holding an svg, which
  // would show up as dead space between these three.
  &:has(svg) {
    padding: 0;
  }

  button {
    height: 36rem;
    padding: 0 16rem;
    gap: 6rem;
    font-size: 14rem;
    white-space: nowrap;
  }

  ${respondTo.smallTablet`
    button {
      padding: 0 12rem;
    }
  `}
`;

// Label dropped: square off the pill so it reads as an icon button rather than
// a button that lost its text.
export const IconNavButton = styled(NavButton)`
  button {
    width: 36rem;
    min-width: 36rem;
    padding: 0;
    gap: 0;
  }
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20rem;
  background-color: ${COLORS.WHITE};
  border: 1rem solid ${COLORS.GREEN};
  overflow: hidden;
`;
